import { sendRequest } from "@/api/clients/axios";

export type GenerateDeliveryReportResponse = { id: number } | number;

export function parseGenerateDeliveryReportId(
  data: GenerateDeliveryReportResponse
): number | undefined {
  if (typeof data === "number") {
    return data;
  }

  if (typeof data?.id === "number") {
    return data.id;
  }

  return undefined;
}

export async function generateDeliveryReport(deliveryId: number | string): Promise<number> {
  const res = await sendRequest<undefined, GenerateDeliveryReportResponse>(
    "get",
    `delivery/generate-report/${deliveryId}`
  );

  return parseGenerateDeliveryReportId(res.data) ?? Number(deliveryId);
}
